var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hper wper bg-primary2"},[_c('graphvis',{ref:"graphvis",on:{"onClickNode":_vm.onClickNode,"onDBClickNode":_vm.onDBClickNode,"onClickLink":_vm.onClickLink,"onRightClickNode":_vm.onRightClickNode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }